/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting Export..." |
*
* @param {Audio_Description_Export_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_starting = /** @type {((inputs?: Audio_Description_Export_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de l'exportation...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio esportazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando Exportación...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导出...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação...")
	return /** @type {LocalizedString} */ ("Starting Export...")
});